module.exports = __webpack_public_path__ + "img/visitor_icon.3b807722.svg";